<template>
    <div class="steps">
        <slot>
        </slot>
    </div>
</template>

<script>
    export default {
        data () {
            return {}
        },
        props: {
            current: {
                type: Number,
                default: 0
            }
        },
        mounted () {
            this.$children.forEach(function (child, index) {
                child.num = index + 1
                if (this.current < 0 || this.current >= this.$children.length) {
                    return
                }

                if (this.current === index) {
                    child.$el.className += ' steps-process'
                } else if (this.current > index) {
                    child.$el.className += ' steps-finish'
                }

                if(index === 2){
                    child.$el.className += ' steps-none'
                }
            }.bind(this))
        }
    }
</script>

<style lang="scss" scoped="">
    @import "../../../scss/common";

    .steps {
        width: 100%;
        max-width: 650px;
        margin: 20px auto;
        display: flex;
    }

    @media only screen and (max-width: 500px) {
        .details {
            .order-payment {
                .payment-left {
                    p {
                        font-size: 14px;
                    }
                }
                .payment-right {
                    text-align: left;
                    p, span {
                        font-size: 14px;
                    }
                }
            }
            .order-list {
                .order-group-header, .listing {
                    display: none;
                }
            }
            .flex-item {
                ul {
                    font-size: 12px;
                }
            }
        }
        .steps {
            flex-direction: column;
            display: inline-block;
            width: 100%;
            .step-list {
               width: 80px !important;
            }
        }
        .steps-int {
            display: block !important;
        }
    }

    @media only screen and (max-width: 768px) {
        .steps {
            width: 100%;
        }
    }
    @media only screen and (max-width: 320px) {
        .steps {
            .step-list {
                width: 65px !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Steps.vue?504b15fc